<div class="margin-top-2">
  @if (filters.length > 0) {
    <strong>Filtering Options</strong>
  }
  @if (filters.length === 0) {
    @for (_ of [].constructor(5); track _; let i = $index) {
      <div>
        <div class="skeleton-text" style="width: 70px; margin-top: 5px"></div>
        <div class="skeleton-box">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 100px"></div>
        </div>
        <div class="skeleton-box">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 80px"></div>
        </div>
        <div class="skeleton-box">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-text" style="width: 90px"></div>
        </div>
      </div>
    }
  }
  @for (filterOption of filters; track filterOption; let j = $index) {
    <div>
      <div style="margin-top: 5px">{{ filterOption.name }}</div>
      @for (
        filter of filterVisibilityMap.get(filterOption.name)
          ? filterOption.filters
          : (filterOption.filters | slice: 0 : 5);
        track filter;
        let i = $index
      ) {
        <div class="form-check mb-1">
          <label class="sr-only" [for]="filterOption.name + '-' + filter.id + '-' + i">
            {{ filter.display }}
          </label>
          <input
            type="checkbox"
            class="form-check-input ml-0"
            [name]="filter.display"
            [id]="filterOption.name + '-' + filter.id + '-' + i"
            [value]="filter.id"
            [(ngModel)]="checkboxes[j + '-' + i]"
            (change)="updateCheckedCount()"
          />
          <label class="form-check-label" [for]="filterOption.name + filter.id">
            {{ filter.display }} ({{ filter.plantIds.length }})
          </label>
        </div>
      }
      @if (filterOption.filters.length > 5) {
        <button
          class="btn-link accessible-blue-on-gray"
          style="text-decoration: none !important; font-weight: bold; padding: 0; border: 0"
          (click)="showMoreOrLessFilters(filterOption)"
        >
          <i [class]="getMoreOrLessFiltersClass(filterOption)"></i>
          {{ getMoreOrLessFiltersText(filterOption) }}
        </button>
      }
    </div>
  }
  @if (hasFiltersBeenApplied) {
    <sidebar-filter-actions
      [currentCount]="checkedCount"
      [filtersStatus]="hasFiltersBeenApplied"
      (applyFilters)="applyFilters()"
      (clearFilters)="clearFilters()"
    >
    </sidebar-filter-actions>
  }
</div>
